import { unwrapResult } from '@reduxjs/toolkit';
import { ButtonCTA, Checkbox, SpinnerSmall, TextField } from 'components/ui';
import querystring from 'querystring';
import { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAppDispatch } from 'store';
import { loginWithShopifyCredentials } from 'store/userDetailsSlice';
import { getStoreNameFromShopifyUrl } from 'utils/helpers';
import { useQuery } from 'utils/useQuery';
import { QueryParam } from './types';

export default function Login() {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const [errorMsg, setErrorMsg] = useState('');

  const query = useQuery();
  const state = query.get(QueryParam.STATE);
  const shop = query.get(QueryParam.SHOP);

  function handleOnSubmit(event: any) {
    event.preventDefault();
    if (!!!state) {
      toast.error(
        'Installation failed, please contact our team for assistance - error: state is a required property',
        { autoClose: 10000 }
      );
      return;
    }
    const { email, password } = event.target;

    const loginPayload = {
      email: email.value,
      password: password.value,
      state,
    };
    setLoading(true);
    dispatch(loginWithShopifyCredentials(loginPayload))
      .then(unwrapResult)
      .then(() => {
        setLoading(false);
        history.replace({
          pathname: '/dashboard/welcome',
          search: querystring.stringify({
            store_name: getStoreNameFromShopifyUrl(shop as string),
          }),
        });
      })
      .catch((err) => {
        setLoading(false);
        toast.error(
          'Login failed, try again or contact our team for assistance',
          { autoClose: 10000 }
        );
      });
  }

  useEffect(() => {
    const inputs = document.querySelectorAll('input');

    inputs.forEach((input) => {
      input.addEventListener(
        'invalid',
        () => {
          input.classList.add(
            'focus:ring-segments-at-risk',
            'focus:border-segments-at-risk'
          );
        },
        false
      );
      input.addEventListener('keyup', (e) => {
        const capslock = e.getModifierState?.('CapsLock');
        if (capslock) {
          setErrorMsg('Note : Your Capslock key is currently turned on');
        } else {
          setErrorMsg('');
        }
      });
    });
  }, []);

  return (
    <div className="mt-8 ">
      <form onSubmit={handleOnSubmit} className="text-2xl font-bold leading-9 ">
        <div className="">
          <label htmlFor="email" className="block text-sm font-bold">
            Email
          </label>
          <TextField
            // @ts-ignore
            name="email"
            type="email"
            placeholder="Required"
            required
          />
          {errorMsg && (
            <p className="text-segments-13px text-segments-at-risk">
              {errorMsg}
            </p>
          )}
        </div>
        <div className="mt-4">
          <label htmlFor="password" className="block text-sm font-bold">
            Password
          </label>
          <TextField
            // @ts-ignore
            name="password"
            type="password"
            placeholder="Required"
            minLength={5}
            maxLength={128}
            required
          />
        </div>
        <div className="flex items-center justify-between mt-8">
          <label htmlFor="rememberMe" className="flex items-center">
            <Checkbox name="rememberMe" />
            <span className="font-normal leading-4 text-segments-13px">
              keep me logged in
            </span>
          </label>
          <Link
            className="font-normal leading-4 text-segments-13px"
            to="/account/reset-password"
          >
            Forgot password{' '}
          </Link>
        </div>
        <div className="items-center justify-end mt-12 lg:flex ">
          <div className="w-full mt-8 lg:mt-0 lg:w-32">
            <ButtonCTA
              type="submit"
              variant="main"
              disabled={loading}
              cursorNotAllowed={loading}
            >
              {loading ? <SpinnerSmall /> : <p>Log in</p>}
            </ButtonCTA>
          </div>
        </div>
      </form>
    </div>
  );
}
